<template>
  <div class="pt-25">
    <div class="category-menu">
      <h3>Trending Products</h3>

      <ul class="product-list product-right-sidebar border-0 p-0">
        <li v-for="listing in listings?.data">
          <div class="offer-product">
            <router-link class="offer-image"
                         :to="listing?.link">
              <img :src="listing?.images?.[0]?.image_url"
                   class="img-fluid blur-up lazyload" alt="">
            </router-link>

            <div class="offer-detail">
              <div>
                <router-link class="offer-image"
                             :to="listing?.link">
                  <h6 class="name">{{ listing?.name }}</h6>
                </router-link>
                <span>
                  {{ listing?.location?.name }}
                </span>
                <h6 class="price theme-color"> KES {{ formatNumber(listing?.price) }}</h6>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GeneralController from '@/mixins/GeneralController'

export default {
  name: "TrendingListings",
  mixins: [GeneralController],
  props: {
    listing_id: null
  },
  computed: {
    ...mapGetters({
      'listings': 'listings/similar_listings'
    }),
  },
  methods: {
    ...mapActions({
      'getListings': 'listings/getSimilarListings'
    })
  },
  created() {
    this.getListings({
      similar: true,
      listing_id: this.listing_id
    })
  }
}
</script>
